import { gql } from "@apollo/client";

export const TEST_TEMPLATE = gql`
  mutation testTemplate(
    $templateId: String!
    $clientIdentifier: String
    $input: TestTemplateInput!
  ) {
    invoiceInterpretation {
      testTemplate(
        templateId: $templateId
        clientIdentifier: $clientIdentifier
        input: $input
      ) {
        errorMessage
        maskedFile {
          content
          contentType
          name
        }
        extractedData {
          currencyCode
          dueDate
          invoiceDate
          invoiceNumber
          issuerName
          issuerOrganizationNumber
          issuerReference
          issuerVatRegistrationNumber
          ocrNumber
          orderReference
          recipientAddress
          recipientAddress2
          recipientCity
          recipientCountryCode
          recipientCustomerNumber
          recipientEmail
          recipientGlobalLocationNumber
          recipientName
          recipientOrganizationNumber
          recipientReference
          recipientVatRegistrationNumber
          recipientZipCode
          roundingAmount
          serviceType
          shippingFeeAmountExcludingVat
          shippingVatRate
          totalAmountExcludingVat
          totalAmountIncludingVat
          totalVatAmount
          vatReverseCharge
          invoiceLines {
            articleNumber
            description
            discountAmount
            discountPercentage
            quantity
            row
            totalAmountExcludingVat
            unit
            unitPriceExcludingVat
            vatRate
          }
        }
      }
    }
  }
`;
